<script>
import Repositories from '@/repositories';
const WorkOrderItemOrderItemsRepository = Repositories.get(
  'workorderitemorderitems'
);
const OrderItemsRepository = Repositories.get('orderitems');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import dateMixin from '@/mixins/dateMixin';

export default {
  components: {
    Loading,
  },
  props: {
    workOrderItem: Object,
    item: Object,
  },
  mixins: [dateMixin],
  data() {
    return {
      isLoading: false,
      orderItemsList: [],
    };
  },
  created() {
    this.refreshItems();
  },
  methods: {
    refreshItems() {
      this.orderItemsList = [];
      this.isLoading = true;

      OrderItemsRepository.customREST
        .getByItem(this.item.idPublic)
        .then((response) => {
          this.orderItemsList = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    requestWOItem(quantity) {
      let apiWrapper = {
        requestedQuantity: quantity,
        reservedQuantity: -1,
      };
      this.$emit('request-reserve', apiWrapper);
    },
    linkWorkOrderItemOrderItem(orderItem) {
      this.isLoading = true;
      let toReserve = this.workOrderItemNonReserved;

      if (orderItem.availableQuantity < toReserve) {
        toReserve = orderItem.availableQuantity;
      }

      let requestedQuantity = -1;

      if (
        this.workOrderItem.totalQuantity <
        this.workOrderItem.reservedQuantity +
          this.workOrderItem.orderedQuantity +
          this.workOrderItem.consumedQuantity +
          this.workOrderItem.requestedQuantity +
          toReserve
      ) {
        requestedQuantity =
          this.workOrderItem.totalQuantity -
          this.workOrderItem.reservedQuantity -
          this.workOrderItem.orderedQuantity -
          this.workOrderItem.consumedQuantity -
          toReserve;
      }

      let payload = {
        orderItemIdPublic: orderItem.idPublic,
        workOrderItemIdPublic: this.workOrderItem.idPublic,
        reservedQuantity: toReserve,
        requestedQuantity: requestedQuantity,
      };

      WorkOrderItemOrderItemsRepository.actions
        .linkWorkOrderItemOrderItem(payload)
        .then((resp) => {
          if (resp.data != null && resp.data == true) {
            this.$emit('update-work-order-item');
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.$emit('refresh-items');
          }

          this.refreshItems();
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgain'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }

          this.$emit('refresh-items');
          this.refreshItems();
          this.isLoading = false;
        });
    },
  },
  computed: {
    workOrderItemNonReserved() {
      if (this.workOrderItem != null) {
        return this.toFloat(
          this.workOrderItem.totalQuantity -
            this.workOrderItem.reservedQuantity -
            this.workOrderItem.orderedQuantity -
            this.workOrderItem.consumedQuantity
        );
      }

      return null;
    },
    orderItemsFilteredList() {
      return this.orderItemsList
        .map((x) => {
          return {
            ...x,
            availableQuantity:
              x.totalQuantity - x.reservedQuantity - x.receivedQuantity,
          };
        })
        .filter((orderItem) => {
          return this.toFloat(orderItem.availableQuantity) > 0;
        });
    },
  },
};
</script>


<template>
  <b-container>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <b-row>
      <b-col>
        <b-button
          @click="requestWOItem(workOrderItemNonReserved)"
          block
          size="lg"
          variant="success"
        >
          {{ $t('items.requestXItems').replace('#', workOrderItemNonReserved) }}
        </b-button>
      </b-col>
    </b-row>
    <b-row
      ><b-col>
        <table class="table table-hover table-nowrap mt-3">
          <thead class="thead-light">
            <tr>
              <th class="table-row-expandable">
                {{ $t('orders.order') }}
              </th>
              <th class="table-row-relative">
                {{ $t('orders.receptionDate') }}
              </th>
              <th class="table-row-relative">
                {{ $t('items.availableQuantity') }}
              </th>
              <th class="table-row-relative">
                {{ $t('general.action') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="orderItem in orderItemsFilteredList"
              :key="orderItem.idPublic"
            >
              <td class="table-row-expandable">
                {{ orderItem.orderNumber }}
              </td>
              <td class="table-row-relative">
                {{ formatDate(orderItem.orderReceptionDate) }}
              </td>
              <td class="table-row-relative">
                {{ toFloat(orderItem.availableQuantity) }}
              </td>
              <td class="table-row-relative">
                <b-dropdown
                  dropleft
                  class="card-drop"
                  variant="link"
                  toggle-class="text-decoration-none p-0"
                  no-caret
                >
                  <template #button-content>
                    <i class="fas fa-ellipsis-h" />
                  </template>
                  <b-dropdown-item
                    @click="linkWorkOrderItemOrderItem(orderItem)"
                  >
                    <i class="fas fa-pen text-success mr-1"></i>
                    {{ $t('orders.reserveOrder') }}
                  </b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
        <h3
          class="text-center"
          v-if="orderItemsFilteredList.length <= 0 && isLoading == false"
        >
          {{ $t('orders.noOrder') }}
        </h3></b-col
      ></b-row
    >
  </b-container>
</template>

<style scoped>
.bigger-text-size {
  font-size: 1.1em;
}
</style>